import React from 'react';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { Skeleton } from 'src/components/ui/skeleton';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { ChangeKnowledgeBaseModal } from './ChangeKnowledgeBaseModal';
import { ProductsType } from 'src/constants/products';
import { useGetKnowledgeBaseQuery } from 'src/services/knowledgeBaseService';

export const ChangeKnowledgeBase = () => {
  const { id } = useParams();
  const { data: currentProject, isFetching: isProjectFetching } = useGetProjectByIdQuery({
    id: id,
  }) as any;

  const { data: knowledgeBaseDataByProjectId, isFetching: isFetchingKnowledgeBaseData } =
    useGetKnowledgeBaseQuery(
      {
        load_projects: false,
        page_size: 100,
        project_ids: id,
      },
      { refetchOnMountOrArgChange: true },
    ) as any;

  const isCustomer = currentProject?.project_type === ProductsType.customer;

  return (
    <div className="flex flex-col gap-1.5 md:w-1/3">
      <div className="title">
        <p className="text-grey_text font-medium text-xs">Knowledge base</p>
      </div>
      <div
        className={
          'input-container full-width border rounded-sm-5 h-full px-4 py-1 flex justify-between items-center gap-2'
        }
      >
        <LoaderWrapper
          loader={
            <div className="flex justify-between w-full items-end">
              <Skeleton className="h-4 w-full" />
            </div>
          }
          isLoading={isProjectFetching || isFetchingKnowledgeBaseData}
        >
          <p
            title={
              knowledgeBaseDataByProjectId?.items?.length
                ? knowledgeBaseDataByProjectId?.items?.map((item) => item.name).join(', ')
                : 'Default'
            }
            className="md:text-base text-sm font-medium text-ebony truncate"
          >
            {knowledgeBaseDataByProjectId?.items?.length
              ? knowledgeBaseDataByProjectId?.items?.map((item) => item.name).join(', ')
              : 'Default'}
          </p>
        </LoaderWrapper>
        <LoaderWrapper
          loader={
            <div className="flex justify-between w-full items-end">
              <Skeleton className="h-4 w-4" />
            </div>
          }
          isLoading={isProjectFetching || isFetchingKnowledgeBaseData}
        >
          <ChangeKnowledgeBaseModal
            currentProject={currentProject}
            disabled={!isCustomer}
            selectedKBIds={knowledgeBaseDataByProjectId?.items?.map((item) => item.id)}
          />
        </LoaderWrapper>
      </div>
    </div>
  );
};
